import { createDomain } from 'effector'

import { LocalStorageKeys } from '@/consts/localStorage'
import { createUserCloneMediaModel } from '@/models/vault/medias/clonned'

import { createUserEditorMediasModel } from './medias/model'
import { createUserEditorTagsModel } from './tags/model'

const createUserEditorModel = (userId: number) => {
  const userDomain = createDomain(`user-${userId}`)

  const cloneMedia = createUserCloneMediaModel(userDomain)
  const medias = createUserEditorMediasModel(userDomain, cloneMedia)
  const tags = createUserEditorTagsModel(userDomain)

  return {
    medias,
    cloneMedia,
    tags,
  }
}

const userEditorModels = new Map<
  number,
  ReturnType<typeof createUserEditorModel>
>()

export const removeUserEditorModel = (userId: number) => {
  userEditorModels.delete(userId)
  const fanMessagesMap = sessionStorage.getItem(LocalStorageKeys.FAN_MESSAGE)

  if (!fanMessagesMap) {
    return
  }

  const persistedFanMessagesMap = JSON.parse(fanMessagesMap)

  delete persistedFanMessagesMap[userId]
  sessionStorage.setItem(
    LocalStorageKeys.FAN_MESSAGE,
    JSON.stringify(persistedFanMessagesMap),
  )
}

export function getUserMessageEditorModels(userId: number) {
  const existingModels = userEditorModels.get(userId)

  if (existingModels) {
    return existingModels
  }

  const models = createUserEditorModel(userId)

  userEditorModels.set(userId, models)

  return models
}
